<template>
	<div id="app" class="min-h-screen bg-gray-50">
		<router-view />
		<Toaster position="top-right" richColors :expand="false" />
		<Toast />
		<ConfirmDialog />
	</div>
</template>

<script setup>
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import { Toaster } from "vue-sonner";
import "vue-sonner/style.css";

const authStore = useAuthStore();

onMounted(() => {
	// Check authentication status on app load
	authStore.checkAuthStatus();
});
</script>
